import { render, staticRenderFns } from "./PpcFormSuccess.vue?vue&type=template&id=4cc50951&"
import script from "./PpcFormSuccess.vue?vue&type=script&lang=js&"
export * from "./PpcFormSuccess.vue?vue&type=script&lang=js&"
import style0 from "./PpcFormSuccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports